// Media Gallery Reducer
import * as App from './reducer-functions';

const blogArticleReducer = (state = window.ArticleData, action) => {
  switch (action.type) {
    case 'FILTER_TOGGLE_CLICK':
      return Object.assign({}, state, App.filterToggleClick(state));

    case 'FILTER_BUTTON_CLICK':
      return Object.assign({}, state, App.buttonClick(state, action));

    case 'CLOSE_ALL_DROPDOWNS':
      return Object.assign({}, state, App.closeAllDropdowns(state, action));

    case 'SELECT_FILTER': {
      const nextState = Object.assign({}, state, App.filterClick(state, action));
      return Object.assign({}, nextState, App.filterArticleItems(state.initialState.articleItems, nextState));
    }

    case 'REMOVE_FILTER': {
      const nextState = Object.assign({}, state, App.removeFilter(state, action));
      return Object.assign({}, nextState, App.filterArticleItems(state.initialState.articleItems, nextState));
    }

    case 'CLEAR_FILTERS': {
      const nextState = Object.assign({}, state, App.clearFilters(state));
      return Object.assign({}, nextState, App.filterArticleItems(state.initialState.articleItems, nextState));
    }

    case 'SEARCH_SUBMIT': {
      const nextState = Object.assign({}, state, App.searchSubmit(state, action));
      return Object.assign({}, nextState, App.filterArticleItems(state.initialState.articleItems, nextState));
    }

    case 'APPLY_BLOG_FILTERS':
      return Object.assign({}, state, App.applyBlogFilters(state, action));

    case 'CLOSE_FILTER_PANEL':
      return Object.assign({}, state, App.closeFilterPanel());

    default:
      return state;
  }
};

export default blogArticleReducer;
